import React from 'react';
import Cookies from 'js-cookie';

const LiveStreamPlayer = ({ unitId }) => {
  const mediamtxHost = process.env.REACT_APP_MEDIAMTX_HOST || window.location.hostname;
  const token = localStorage.getItem('jwt-token');
  console.log('JWT Token for streaming:', token ? 'Present' : 'Missing');
  const stream1Url = `http://${mediamtxHost}:8889/unit${unitId}${token ? `?user=${encodeURIComponent(token)}` : ''}`;
  const stream2Url = `http://${mediamtxHost}:8889/unit${unitId}_cam1${token ? `?user=${encodeURIComponent(token)}` : ''}`;

  return (
    <div className="videos-container" style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '10px',
      marginBottom: '10px'
    }}>
      <div style={{ position: 'relative', background: '#000', width: '100%', paddingBottom: '56.25%' }}>
        <iframe 
          src={stream1Url} 
          title="Camera 1" 
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }} 
        />
        <div style={{ position: 'absolute', bottom: 8, left: 8, fontSize: '12px', color: '#fff', background: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '3px' }}>
          Camera 1
        </div>
      </div>
      <div style={{ position: 'relative', background: '#000', width: '100%', paddingBottom: '56.25%' }}>
        <iframe 
          src={stream2Url} 
          title="Camera 2" 
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }} 
        />
        <div style={{ position: 'absolute', bottom: 8, left: 8, fontSize: '12px', color: '#fff', background: 'rgba(0,0,0,0.6)', padding: '4px 8px', borderRadius: '3px' }}>
          Camera 2
        </div>
      </div>
    </div>
  );
};

export default LiveStreamPlayer;
